import BaseOption from "%/dynamic-component-editor/classes/base-option";
import { inspectorTools } from "%/dynamic-component-editor/inspector/inspector-tool-map";

export default class FeedVideoAutoplay extends BaseOption {
  static userInterfaceComponent = {
    label: "Autoplay Videos",
    component: inspectorTools.RADIO_BAR,
    optionDataType: BaseOption.DataType.Boolean,
    descriptionMessage:
      "Play each post's video, muted, when it scrolls into view. Only one plays at a time.",
    props: {
      options: [
        { label: "On", value: true, tooltip: "" },
        { label: "Off", value: false, tooltip: "" },
      ],
    },
  };

  static defaultValue = false;
}
